import { IonButton } from "@ionic/react";
import "./StyledButton.css";

export default function StyledButton(props) {
  return <IonButton {...props} />;
}
